import React from 'react'
import styles from './Cta.css'
import Button from '../../../../components/Button'
import Header from '../Header'

const Cta = () => (
  <div className={styles.wrapper}>
    <Header className={styles.header}>Bewaar jouw smaakprofiel</Header>
    <p className={styles.text}>
      Ontvang direct 2 &times; 25% korting op een fles uit jouw&nbsp;smaakprofiel</p>
    <Button
      className='icon-after'
      baseClassName='actionButton'
      clickHandler={() => {
        const event = document.createEvent('Event')
        event.initEvent('showSaveTasteProfilePopup', true, true)
        window.dispatchEvent(event)
      }}
    >
      Sla je smaakprofiel op
      <svg className="icon">
        <use xlinkHref="#icon_pijl_rechts" />
      </svg>
    </Button>
  </div>
)

export default Cta
